/** Named viewport width thresholds in pixels. */
export const breakpoints = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
  desktopMedium: 1200,
  desktopLarge: 1440,
  desktopXL: 1920,
} as const;

export type Breakpoint = keyof typeof breakpoints;

/** `min-width` media query strings — use for mobile-first styles that activate at and above a breakpoint. */
export const media = {
  mobile: `@media (min-width: ${breakpoints.mobile}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  desktopMedium: `@media (min-width: ${breakpoints.desktopMedium}px)`,
  desktopLarge: `@media (min-width: ${breakpoints.desktopLarge}px)`,
  desktopXL: `@media (min-width: ${breakpoints.desktopXL}px)`,
} as const;

// TODO(future): Consider adopting a mobile-first convention by defaulting to `media` (min-width)
// for new components. Mobile-first means base styles target the smallest viewport with progressive
// overrides upward — smaller devices parse fewer rules and the cascade flows simple → complex.
// `mediaMax` would then be reserved for targeted exceptions rather than the primary approach

/**
 * `max-width` media query strings — use for styles that apply up to and including a breakpoint.
 */
export const mediaMax = {
  mobile: `@media (max-width: ${breakpoints.mobile}px)`,
  tablet: `@media (max-width: ${breakpoints.tablet}px)`,
  desktop: `@media (max-width: ${breakpoints.desktop}px)`,
  desktopMedium: `@media (max-width: ${breakpoints.desktopMedium}px)`,
  desktopLarge: `@media (max-width: ${breakpoints.desktopLarge}px)`,
  desktopXL: `@media (max-width: ${breakpoints.desktopXL}px)`,
} as const;
